export var RegistrationStep = /*#__PURE__*/function (RegistrationStep) {
  RegistrationStep["membershipTypeSelection"] = "membershipTypeSelection";
  RegistrationStep["forms"] = "forms";
  RegistrationStep["summary"] = "summary";
  RegistrationStep["complete"] = "complete";
  return RegistrationStep;
}(RegistrationStep || {});
export const defaultRegistrationSteps = [RegistrationStep.membershipTypeSelection, RegistrationStep.forms, RegistrationStep.summary, RegistrationStep.complete];